export default __webpack_public_path__ + "static/media/numpy.071f2a8e.svg";